// extracted by mini-css-extract-plugin
export default {"arrowLink":"BackButton_arrowLink__LaAqg","backIcon":"BackButton_backIcon__2pj-B"};